module.exports = __webpack_public_path__ + "img/shouye_kehu02.dbdc461f.png";